// src/contexts/AuthContext.js
import React, { createContext, useContext, useState } from 'react';
import { UserRoleType } from 'types/userRoles';

type AuthContextType = {
    currentUser: any;
    userRoles: string[];
    setUserRoles: React.Dispatch<React.SetStateAction<UserRoleType[]>>;
    setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean;
    isAuthenticated: boolean;
};

// Create a simple auth context
const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    // Add state management for user roles
    const [userRoles, setUserRoles] = useState<UserRoleType[]>([]);
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    const value: AuthContextType = {
        // Empty placeholder values to satisfy component dependencies
        currentUser: null,
        userRoles,
        setUserRoles,
        setIsAuthenticated,
        loading: false,
        isAuthenticated,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
